module.exports = __webpack_public_path__ + "img/48.e0054d42.jpg";